/**
 * Draft listing review UI constants (M13).
 */
export const DRAFT_REVIEW_STATUS_LABELS_ES = {
  needs_review: "Requiere revisión",
  missing_required_data: "Faltan datos",
  needs_normalization: "Requiere normalización",
  needs_price_review: "Requiere revisión de precio",
  needs_location_review: "Requiere revisión de ubicación",
  needs_photos: "Requiere fotos",
  ready_to_publish: "Listo para publicar",
  blocked: "Bloqueado",
  published: "Publicado",
};

export const DRAFT_REVIEW_ACTION_LABELS_ES = {
  mark_data_reviewed: "Marcar datos revisados",
  mark_price_reviewed: "Marcar precio revisado",
  mark_location_reviewed: "Marcar ubicación revisada",
  mark_normalization_reviewed: "Marcar normalización revisada",
  mark_photos_reviewed: "Marcar fotos revisadas",
  mark_ready_to_publish: "Marcar listo para publicar",
  mark_blocked: "Marcar bloqueado",
  add_review_note: "Agregar nota",
  apply_normalization_suggestion: "Aplicar normalización sugerida",
};

export function formatDraftReviewStatus(status) {
  return DRAFT_REVIEW_STATUS_LABELS_ES[status] || status || "—";
}

export function draftReviewStatusBadgeClass(status) {
  if (status === "ready_to_publish") return "lead-badge lead-badge--success";
  if (status === "blocked") return "lead-badge lead-badge--danger";
  if (status === "needs_photos" || status === "needs_price_review") return "lead-badge lead-badge--warning";
  return "lead-badge lead-badge--info";
}
